import { apiClient } from '@/services/api';

/** Exchange account authentication only with our API, never with a media URL. */
export async function getLiveReadCredential(
  src: string,
  signal: AbortSignal
): Promise<string> {
  const url = new URL(src, window.location.href);
  const parts = url.pathname.replace(/\/+$/, '').split('/');
  const path =
    parts[parts.length - 1] === 'whep'
      ? parts[parts.length - 2]
      : parts[parts.length - 1];
  const response = await apiClient.client.post(
    '/live-media/credentials',
    { path, action: 'read' },
    { signal }
  );
  const { token, whepUrl } = response.data.data;
  // Do not leak even a scoped credential to an arbitrary externally supplied URL.
  const canonical = new URL(whepUrl);
  if (canonical.origin !== url.origin || canonical.pathname !== url.pathname) {
    throw new Error('Unexpected live media endpoint');
  }
  return token;
}
